// @ts-check
import RoleTabPanel from './tab-panel.js';

RoleTabPanel.define('role-tab-panel');

export default RoleTabPanel;
export * from './tab-panel.js';

/**
 * @type {import("./tab-panel-globals.js")}
 */
